
import { Condition } from "@/utils/condition/condition";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import AppConditionsEdit from "@/components/models/ConditionsEdit.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			tempConditions: [] as Condition[]
		};
	},
	props: {
		value: {
			type: Array as ()=>Condition[],
			required: true
		},
		fields: {
			type: Object as ()=>PropSelectGroup,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.tempConditions = this.value.map(c=>new Condition(c.getJSON()));
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.tempConditions.map(c=>new Condition(c.getJSON())));
			this.close();
		}
	},
	components: {
		AppConditionsEdit
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
